import React from 'react';
import classes from './Header.css';
//import isLogo from '../../assets/inStream_Logo.png';

const header = (props) => {

    return (
        <div className={classes.Header}>
            <div className={classes.isLogo}>{/*<img alt="inStream Solutions" src={isLogo} />*/}</div>
            <div className={classes.title}>Portfolio Simulator {props.additionalInfo}</div>
            <div className={classes.clientLogo}></div>

        </div>
    );

};

export default header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js